module.exports = __webpack_public_path__ + "img/3.5a486a21.jpg";